<template>
    <div>
        <v-card class="elevation-12">
            <v-toolbar dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Template: {{ templateToEdit.name }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="$router.push('/admin/admin-quote-templates')" small color="primary">Back</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-flex xs12 class="text-xs-center">
                    <v-btn @click="onCreateNewTemplateItem" small color="primary" >Add New Item</v-btn>

                </v-flex>
                <v-data-table
                    :headers="headers"
                    :items="templateToEdit.templateItems"
                    hide-actions
                    :dense="true"
                    class="condensed-datatable"
                    >
                    <template slot="items" slot-scope="props">
                      <td class="px-1" style="width: 20px;">
                        {{props.item.itemNumber}}
                        </td>
                        <td class="px-1 text-xs-center" style="width: 10px;">
                            <v-text-field 
                                v-model="props.item.sortNo" 
                                type="number"
                                label=""
                                style="font-size: 12px;"
                                ></v-text-field>
                        </td>
                      <td class="px-1 text-no-wrap" style="width: 20%;">
                        <v-text-field 
                            v-model="props.item.itemCategory" 
                            type="text"
                            label=""
                            style="font-size: 12px;"
                            ></v-text-field>
                      </td>
                      <td class="px-1">
                        <v-text-field 
                            v-model="props.item.itemDesc" 
                            type="text"
                            label=""
                            style="font-size: 12px;"
                            ></v-text-field>
                        </td>
                      <td class="px-1 text-xs-center text-no-wrap" style="width: 15px;">
                        <v-text-field 
                            v-model="props.item.itemUnit" 
                            type="text"
                            label=""
                            style="font-size: 12px;"
                            ></v-text-field>
                        </td>
                        <td class="text-xs-center " style="width: 10px;">
                            <v-checkbox
                                v-model="props.item.active"
                                label=""
                                ></v-checkbox>
                        </td>
                        <!-- <td style="width: 20%;">
                            <v-btn small color="primary" 
                                @click.prevent="$emit('onEditItem', props.item)" >Save</v-btn>
                            <v-btn small color="primary" @click.prevent="$emit('onDeleteItem', props.item)" >Delete</v-btn>
                        </td> -->
                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-btn color="primary" @click.prevent="onUpdateQuoteTemplateItems">Save</v-btn>
                    <v-btn color="warning" @click.prevent="$emit('onCloseItemTemplate')">Cancel</v-btn>
                </div>
            </v-card-text>
        </v-card>
        <v-dialog v-model="showItemAddNewPopup" width="500" height="400">
            <ctlTemplateItemEdit @onSaveItem="onAddTemplateItem" :originalItemData="templateItemToEdit"
                ></ctlTemplateItemEdit>
        </v-dialog>
    </div>
</template>
<script>
import ctlTemplateItemEdit from '@/components/admin/ctlTemplateItemEdit.vue'
import { mapActions } from 'vuex'
export default {
    // props: ['itemDocs'],
    components: {
        ctlTemplateItemEdit,
    },
    data() {
        return {
            headers: [
                { text: 'Item No', sortable: false},
                { text: 'Sort No', sortable: false, class: ['px-1']},
                { text: 'Product Category', sortable: false},
                { text: 'Item Description' , sortable: false},
                { text: 'Unit' , sortable: false},
                { text: 'Active' , sortable: false},
            ],
            templateToEdit: {},
            showItemAddNewPopup: false,
            templateItemToEdit: {},
        }
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        error() {
            return this.$store.getters.error;
        }
    },
    methods: {
        ...mapActions('adminQteTemplate', [
            'getQuoteTemplateForEdit',
            'updateQuoteTemplateItems'
        ]),
        async getQteTemplate() {
            this.templateToEdit = await this.getQuoteTemplateForEdit({
                templateId: this.id,
                active: true
            })
        },
        async onUpdateQuoteTemplateItems() {
            var result = await this.updateQuoteTemplateItems(this.templateToEdit)
            console.log('result')
            console.log(result)
            this.getQteTemplate();
        },
        async onCreateNewTemplateItem() {
            this.templateItemToEdit = {
                templateId: this.id,
                sortNo: this.templateToEdit.templateItems? this.templateToEdit.templateItems.length + 1 : 1,
                active: true,
            }
            this.showItemAddNewPopup = true
            console.log(this.templateItemToEdit)
        },
        async onAddTemplateItem() {
            this.showItemAddNewPopup = false
            this.getQteTemplate()
        }
    },
    created() {
        this.getQteTemplate()
    }
}
</script>
<style scoped>
.v-text-field__slot input {
  font-size: 12px;
}
</style>